import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { toFullName } from '@repo/toolkit/to-full-name'
import { MODAL_CONTENT_CLASSNAME } from '@repo/ui/modal'
import { useQuery } from '@tanstack/react-query'
import { useForm } from 'react-hook-form'

import { AssignLecResponsableToCentersInput } from '../../../api/centers/assign-lec-responsable'
import { getUsers } from '../../../api/user/get-users'
import { RoleEnum } from '../../../lib/types/enums/users/role.enum'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { getSelectedOption } from '../../../lib/utils/functions/misc.functions'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledSelectInput from '../../elements/inputs/controlled-select-input'
import ValidationButtons from '../../elements/validation-buttons'
import { ASSIGN_LEC_RESPONSABLE_SCHEMA } from './center.utils'

const RequestStaffForm = ({
  defaultValues,
  ...validationButtonProps
}: BaseFormProps<AssignLecResponsableToCentersInput, true>) => {
  const form = useForm<AssignLecResponsableToCentersInput>({
    resolver: zodResolver(ASSIGN_LEC_RESPONSABLE_SCHEMA),
    defaultValues,
    mode: FORM_MODE
  })

  const { data: users } = useQuery({
    queryKey: ['users', 'admins'],
    queryFn: () => getUsers({ filter: { roles: [RoleEnum.ADMIN] } })
  })

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}
        className={cn('flex flex-col gap-3', MODAL_CONTENT_CLASSNAME)}
      >
        <FormField
          control={form.control}
          name="lecResponsableId"
          render={({ field }) => {
            return (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledSelectInput
                    {...field}
                    dropDownPosition="above"
                    options={users?.data.map((user) => ({
                      label: toFullName(user.firstName, user.lastName),
                      value: user.id
                    }))}
                    label={'Responsable secteur'}
                    selectedOption={getSelectedOption(
                      field.value,
                      toFullName(
                        users?.data.find((user) => user.id === field.value)?.firstName,
                        users?.data.find((user) => user.id === field.value)?.lastName
                      )
                    )}
                  />
                </FormControl>
              </FormItem>
            )
          }}
        />

        <ValidationButtons {...validationButtonProps} />
      </form>
    </Form>
  )
}

export default RequestStaffForm
